import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, NgZone, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Common } from 'src/app/common';
import { HomeComponent } from 'src/app/modules/home/home.component';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';
import { ExcelDownloadService } from 'src/app/shared/services/excel-download.service';
import { ExcelService } from 'src/app/shared/services/excel.service';
import { FileService } from 'src/app/shared/services/file.service';
import { MasterService } from 'src/app/shared/services/master.service';
import { RegistrationService } from 'src/app/shared/services/registration.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-employee-leave-report',
  templateUrl: './employee-leave-report.component.html',
  styleUrls: ['./employee-leave-report.component.css'],
})
export class EmployeeLeaveReportComponent implements OnInit {
  empLeaveRptForm: FormGroup;
  submitted: boolean = false;
  dsgntnLst: any[] = [];
  lstGrid: any[] = [];
  dtOptions: any = {};
  dtRender: boolean = true;
  EnableHumanMMU: boolean = true;
  Is1962LiveStock: boolean = true;
  max_date = new Date();
  minDate: Date;
  minToDate: Date;
  mvuLst: any[]=[];
  selectedMMUList: any[]=[];
  selectedDesList: any[]=[];
  dropdownSettings_MMU:any={};
  dropdownSettings_des:any={};
  tenantId:any;
  roleId:any;
  userId:any;
  search_string:any;
  CurpageNumber: any = 0;
  NextpageNumber: any = 0;
  PrevpageNumber: any = 0;
  totalElements: any = 0;
  rowIndex: any = 0;
  pageSize: any = 15
  excelData: any;
  screennames: any;

  get f() {
    return this.empLeaveRptForm.controls;
  }
  constructor(
    config: NgbModalConfig,
    public homeComponent: HomeComponent,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private router: Router,
    private formBuilder: FormBuilder,
    private authSvc: AuthenticationService,
    private regService: RegistrationService,
    private datePipe: DatePipe,
    private excelDownloadService: ExcelDownloadService,
    private excelService: ExcelService,
    private masterService: MasterService,
    public changeDetection: ChangeDetectorRef,
    private fileService: FileService,
    private active: ActivatedRoute,
    private zone: NgZone
  ) {
    this.tenantId = sessionStorage.getItem('TENANT_ID');
    this.roleId =sessionStorage.getItem('logUsrRoleId')
    this.userId = sessionStorage.getItem('loginId');
  }

  ngOnInit() {
    this.dropdownSettings_MMU = {
        singleSelection: false,
        idField: 'mvu_id',
        textField: 'mvu_name',
        selectAllText: 'Select All',
        unSelectAllText: 'Deselect All',
        itemsShowLimit: 3,
        enableCheckAll: true,
        closeDropDownOnSelection: true,
        allowSearchFilter: true
      };
    this.dropdownSettings_des = {
        singleSelection: false,
        idField: 'id',
        textField: 'user_type',
        selectAllText: 'Select All',
        unSelectAllText: 'Deselect All',
        itemsShowLimit: 3,
        enableCheckAll: true,
        closeDropDownOnSelection: true,
        allowSearchFilter: true
      };
     this.screennames = JSON.parse(sessionStorage.getItem('menu'));
    this.getFeaturePermissionList();
    this.initFormControls();
    this.loadDsgntn();
    this.getMvuList();
  }

   getFeaturePermissionList() {
      var featureList: any = JSON.parse(localStorage.getItem('featuresList')) || [];
      for (let i = 0; i < featureList.length; i++) {
        if (featureList[i].feature_id.feature_name == "1962LiveStock") {
          this.Is1962LiveStock  = featureList[i].patient;
        }
        
        if (featureList[i].feature_id.feature_name == "EnableHumanMMU") {
          
          this.EnableHumanMMU = featureList[i].patient;
        }

      }
  }

  initFormControls() {
    this.empLeaveRptForm = this.formBuilder.group({
      from_date: [new Date(), Validators.required],
      to_date: [new Date(), Validators.required],
      mvu_id: [''],
      designation: [''],
    });
  }

  loadDsgntn() {
    this.regService.get(`mvu/empappliedleaves/master-user-types`).subscribe({
      next: (res) => {
        if (res.status == 'OK') {
          this.dsgntnLst = res.data ?? [];
        } else {
          let errMsg: string = res.message;
          this.toastr.error(errMsg);
        }
      },
      error: (err: HttpErrorResponse) => {
        this.toastr.error(err.message);
        // this.dtRender=true
      },
      complete: () => {
        // Any additional logic after patching values
      },
    });
  }

    getMvuList(){
       let api: any;
    if (Number(this.roleId) === 63 || Number(this.roleId) === 52) {
      let coordinatorData = JSON.parse(sessionStorage.getItem('userDetails') || '{}');
      api = `mvu/coordinator-mvu-mapping/getmvulistbycoordinatorid/${coordinatorData.id}`
    }else{
      api = `mvu/mapping/getall`
    }
        this.regService.get(api).subscribe({
          next: res => {
            if (res.status == 'OK') {
               this.mvuLst = res.data??[]
      
            } else {
              let errMsg: string = res.message;
              this.toastr.error(errMsg);
            }
          },
          error: (err: HttpErrorResponse) => {
            this.toastr.error(err.message);
      
          },
          complete: () => {
            // Any additional logic after patching values
          },
        }); 
      }

    // MMU multiselect start
    onAllItemSelectMMU(item:any){
      let list=[];
      list.push(this.mvuLst.map(item => item.mvu_id));
      this.selectedMMUList=list[0]
      console.log("All Sel MMU",  this.selectedMMUList);
    }
    onAllItemDeSelectMMU(item:any){
      this.selectedMMUList=[];
      console.log("All Des MMU",  this.selectedMMUList);
    }
    onItemSelectMMU(item:any){
      if (this.mvuLst.filter(f => f.mvu_id == item.mvu_id)){
        this.selectedMMUList.push(item.mvu_id);
      }   
      console.log("single sel MMU", this.selectedMMUList);
    }
    onItemDeSelectMMU(item:any){
      var data =  this.selectedMMUList;
      data.forEach((x, i) => {
        if (x == item.mvu_id) data.splice(i, 1);
      });
  
      this.selectedMMUList = [...data];
      console.log("single Del MMU", this.selectedMMUList);
    }
    // des multiselect start
    onAllItemSelectDes(item:any){
      let list=[];
      list.push(this.dsgntnLst.map(item => item.id));
      this.selectedDesList=list[0]
      console.log("All des",  this.selectedDesList);
    }
    onAllItemDeSelectDes(item:any){
      this.selectedDesList=[];
      console.log("All del des",  this.selectedDesList);
    }
    onItemSelectDes(item:any){
      if (this.dsgntnLst.filter(f => f.id == item.id)){
        this.selectedDesList.push(item.id);
      }   
      console.log("single sel des", this.selectedDesList);
    }
    onItemDeSelectDes(item:any){
      var data =  this.selectedDesList;
      data.forEach((x, i) => {
        if (x == item.id) data.splice(i, 1);
      });
  
      this.selectedDesList = [...data];
      console.log("single Del des", this.selectedDesList);
    }

   loadData(page_number) {
    //  this.submitted = true,
    //       Common.getFormValidationErrors(this.empLeaveRptForm);
    //     if (this.empLeaveRptForm.invalid) {
    //       this.toastr.info('Please Enter All Mandatory Fields');
    //       return;
    //     }
   let payload= {
        from_date: this.datePipe.transform(this.empLeaveRptForm.value.from_date,'yyyy-MM-dd'),
        to_date: this.datePipe.transform(this.empLeaveRptForm.value.to_date,'yyyy-MM-dd'),
        page: page_number,
        size: this.pageSize,
        search_string: this.search_string || '',
        mvu_ids: this.empLeaveRptForm.value.mvu_id.length > 0 ? this.selectedMMUList : [-1],
        user_type_ids: this.empLeaveRptForm.value.designation.length > 0 ? this.selectedDesList : [-1]
    }
    
    
    this.regService.post(`mvu/empappliedleaves/emp-leave-report`, payload).subscribe({
      next: res => {
        if (res.status == 'OK') {
          if (res.data?.content.length > 0) {
            this.totalElements = res['data']['totalElements'];
            this.lstGrid = res.data?.content;
            this.toastr.success(res.message)

            if ((res.data["totalPages"] == 1) || (this.lstGrid.length <= this.pageSize && res.data["totalPages"] == this.NextpageNumber + 1)) {
              this.CurpageNumber = res.data["number"];
              this.NextpageNumber = 0;
              if (res.data.last == false) {
                this.NextpageNumber = res.data["number"] + 1;
              }
              this.PrevpageNumber = res.data["number"] - 1;

            } else {
              this.CurpageNumber = res.data["number"];
              this.NextpageNumber = res.data["number"] + 1;
              this.PrevpageNumber = res.data["number"] - 1;
              this.rowIndex = 0;
            }
            this.rowIndex = this.CurpageNumber * this.pageSize;

          }
          else {
            this.toastr.warning("No records found");
            this.CurpageNumber = 0;
            this.NextpageNumber = 0;
            this.PrevpageNumber = 0;
            this.totalElements = 0;
            this.lstGrid = [];
          }
        } else {
          this.lstGrid = [];
          this.CurpageNumber = 0;
          this.NextpageNumber = 0;
          this.PrevpageNumber = 0;
          this.totalElements = 0;
          let errMsg: string = res.message;
          this.toastr.error(errMsg);
        }
      },
      error: (err: HttpErrorResponse) => {
        this.toastr.error(err.message);

      },
      complete: () => {
        // Any additional logic after patching values
      },
    });
  }

downLoadExcelKpi(){
    let payload= {
      from_date: this.datePipe.transform(this.empLeaveRptForm.value.from_date,'yyyy-MM-dd'),
      to_date: this.datePipe.transform(this.empLeaveRptForm.value.to_date,'yyyy-MM-dd'),
      page: 0,
      size: this.totalElements,
      search_string: this.search_string || '',
      mvu_ids: this.empLeaveRptForm.value.mvu_id.length > 0 ? this.selectedMMUList : [-1],
      user_type_ids: this.empLeaveRptForm.value.designation.length > 0 ? this.selectedDesList : [-1]
    }

this.regService.post(`mvu/empappliedleaves/emp-leave-report`, payload).subscribe({
      next: res => {
        if (res.status == 'OK') {
          if (res.data['content'].length > 0) {
            this.totalElements = res['data']['totalElements'];
            this.excelData = res.data['content'];
            const fileName = 'Employee Leave Report List'
             this.excelData.forEach((el:any) => {
              el.from_date= this.datePipe.transform(el.from_date, 'dd-MM-yyyy'),
              el.to_date= this.datePipe.transform(el.to_date, 'dd-MM-yyyy')
            })
            var excelData = this.excelData;
            if (excelData.length > 0 ) {
              const excelHeaders = ['Employee Name','Designation','Mobile','MMU Name', 'Leave Type','Leave Taken From','Leave Taken To'];  
              const internalHeaders = ['name', 'user_type', 'mobile_no', 'mvu_name', 'leave_type', 'from_date', 'to_date'];

              this.toastr.success('Please wait excel is downloading')
              this.excelDownloadService.downloadExcel(excelHeaders, internalHeaders, fileName, excelData)
            }

          }
        }
      }
    });
  }

   viewDocument(path:any){
  let webURL = location.href.includes('localhost') ? environment.applicationURL : location.origin;
  const finalUrl = `${webURL}/${path}`;
  window.open(finalUrl, "_blank");  

  }
}
